
export default {
  'navbar.lang': 'Français',
  'menu.home': 'Accueil',
  'menu.dashboard': 'Tableau de bord',
  'menu.profile': 'Profil',
  'menu.settings': 'Paramètres',

  'user.login.title': 'Scan réussi !',
  'user.login.subtitle': 'Fournissez vos informations pour continuer',
  'user.login.username': "Nom d'utilisateur ou email",
  'user.login.password': 'Mot de passe',
  'user.login.forgot': 'Mot de passe oublié ?',
  'user.login.button': 'Se connecter',

  'user.register.title': 'Créer un nouveau compte',
  'user.register.button': "S'inscrire",
  'user.register.success': "Compte créé. Vérifiez l'email pour confirmer.",

  'user.login.welcome.subheading': "Bienvenue dans un monde où la liberté rencontre une vie unique ! Scannez. Gagnez des points. Vivez libre. Vivez unique",
  'user.login.description': "Vous avez scanné notre QR code avec succès. Connectez-vous ou inscrivez-vous ci-dessous pour réclamer des récompenses, des points et gagner des prix incroyables",
  'user.login.signin.title': 'Se connecter',
  'user.login.signin.sub': 'Pour vous connecter, veuillez entrer votre numéro de téléphone ; nous enverrons un code de vérification',
  'user.login.phoneNumberLabel': 'Numéro de téléphone',
  'user.login.enterPhonePlaceholder': 'Entrez le numéro de téléphone',
  'user.login.invalidPhone': 'Numéro de téléphone invalide',
  'user.login.phoneRequired': 'Le numéro de téléphone est requis',
  'user.login.signingIn': 'Connexion...',
  'user.login.continue': 'Continuer',
  'user.login.noAccount': "Vous n'avez pas de compte ?",
  'user.login.signup': "S'inscrire",
  'user.login.footerCopyright': 'Copyright © {year}. Propulsé par Exceptional Brands',

  'user.register.welcome': 'Bienvenue !',
  'user.register': "Inscrivez-vous pour réclamer vos récompenses",
  'user.register.description': "Complétez vos informations ci-dessous pour gagner des points, débloquer des récompenses et gagner des prix incroyables",
  'user.register.phone.label': 'Numéro de téléphone',
  'user.register.phone.placeholder': 'Entrez le numéro de téléphone',
  'user.register.phone.required': 'Le numéro de téléphone est requis',
  'user.register.phone.invalid': 'Numéro de téléphone invalide',
  'user.register.name.label': 'Votre nom',
  'user.register.name.placeholder': 'ex. : Mark',
  'user.register.name.required': 'Le nom est requis',
  'user.register.ageGroup.label': "Tranche d'âge (Optionnel)",
  'user.register.gender.label': 'Genre (Optionnel)',
  'user.register.gender.male': 'Homme',
  'user.register.gender.female': 'Femme',
  'user.register.terms.agreement': 'En continuant, vous acceptez nos {termsLink} et {privacyLink}.',
  'user.register.terms.termsOfService': "Conditions d'utilisation",
  'user.register.terms.privacyPolicy': 'Politique de confidentialité',
  'user.register.creating': 'Création du profil…',
  'user.register.create': 'Créer le profil',
  'user.register.alreadyAccount': 'Vous avez déjà un compte ?',
  'user.register.signin': 'Se connecter',
  'user.register.footer.copyright': 'Copyright © {year}. Propulsé par Exceptional Brands',

  "user.welcome.welcome": "Bienvenue !",
  "user.welcome.welcome_name": "Bienvenue {name} !",
  'user.welcome.points_earned': 'Félicitations, vous avez reçu',
  'user.welcome.thank_you': "Merci pour votre inscription !",
  'user.welcome.earn_more_points': "Pour gagner plus de points, évaluez plus de produits que vous avez achetés chez nous.",
  'user.welcome.continue': 'Continuer',
  'user.welcome.logging_in': 'Connexion...',
  "user.welcome.welcome_reward": "Récompense de bienvenue",
  "user.welcome.points_label": "points!",
  "user.welcome.loggingIn": "Connexion...",

  "product.button.continue": "Continuer",
  "product.button.selectToContinue": "Sélectionnez un produit pour continuer",

  'scansuccess.review.heading': "Comment évalueriez-vous ce produit ?",
  'scansuccess.review.continue': "Code revendeur (Optionnel)",
  'scansuccess.review.select-product': 'Ajoutez un code revendeur pour gagner plus de points',
  'scansuccess.review.review-products': "Soumettre l'évaluation",

  "product.retailerCode.label": "Code revendeur",
  "product.retailerCode.requiredLabel": "Requis",
  "product.retailerCode.optionalLabel": "Optionnel",
  "product.retailerCode.placeholder": "Entrez le code revendeur",
  "product.retailerCode.aria": "Code revendeur",
  "product.retailerCode.hintRequired": "Le code revendeur est requis pour soumettre cet avis",
  "product.retailerCode.hintOptional": "Ajoutez un code revendeur pour gagner plus de points",
  "product.retailerCode.error.required": "Le code revendeur est requis",
  "product.retailerCode.error.invalid": "Code revendeur invalide",

  "profile.title": "Mon profil",
  "profile.tier.member": "Membre",
  "profile.points": "Points",
  "profile.pointsEarned": "Points gagnés",
  'scansuccess.continue': 'Continuer',
  "profile.completeTitle": "Complétez votre profil",
  "profile.completeSubtitle": "Gagnez {points} points bonus !",
  "profile.completedTitle": "Profil complété ! ✓",
  "profile.completedSubtitle": "Vous avez gagné tous les {points} points bonus !",
  "profile.completeButton": "Compléter le profil (+{points} pt)",
  "profile.redeem": "✓ Profil complété",
  "product.review.placeholder": "Rédigez un avis... (un seul caractère suffit)",
  "product.review.ariaLabel": "Rédigez un avis",
  "profile.field.phoneNo.label": "Numéro de téléphone",
  "profile.field.phoneNo.add": "Ajoutez votre numéro",
  "profile.field.email.label": "Adresse e-mail",
  "profile.field.email.add": "Ajoutez votre e-mail",
  "profile.field.countryCode.label": "Localisation",
  "profile.field.countryCode.add": "Ajoutez votre localisation",
  "profile.field.name.label": "Nom",
  "profile.field.name.add": "Ajoutez votre nom",
  "profile.field.dateOfBirth.label": "Date de naissance",
  "profile.field.dateOfBirth.add": "Ajoutez votre date de naissance",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Mettre à jour {field}",
  "profile.modal.completeTitle": "Compléter votre profil",
  "profile.modal.update": "Mettre à jour",
  "profile.modal.complete": "Compléter le profil",
  "profile.modal.cancel": "Annuler",
  "profile.completedBadge": "Vous avez gagné {points} points",
  "profile.progressPercent": "{percent}% Terminé",
  "profile.progressRemaining": "{percent}% restant",
  'scansuccess.congratulations.heading': 'Félicitations !',
  'scansuccess.congratulations.continue': 'Vous avez reçu',
  'scansuccess.congratulations.select-product': "Merci pour votre évaluation",
  'scansuccess.congratulations.review-products': "Pour gagner plus de points, évaluez plus de produits achetés chez nous",
  'scansuccess.congratulations.create': 'Aller au tableau de bord',
  'user.brand-product-review.title': 'Sélectionner marque et produit pour continuer',
  'user.brand-product-review.continue': 'Continuer',
  'user.brand-product-review.select-product': 'Sélectionnez un produit pour continuer',
  'user.brand-product-review.review-products': "Évaluez nos produits pour obtenir des points",
  'user.brand-product-review.rate-product': 'Veuillez évaluer au moins un produit ci-dessus pour continuer',
  'user.brand-product-review.footer': 'Copyright © {year}. Propulsé par Exceptional Brands',
  'scansuccess.title': 'Résultats du scan',
  'scansuccess.scan.message': 'Merci — votre scan a réussi.',
  'scansuccess.scan.instructions': "Vous pouvez réclamer des points, rédiger un avis ou vous inscrire aux offres.",
  'scansuccess.signup.title': 'Inscrivez-vous pour réclamer des récompenses',
  'scansuccess.signup.button': "S'inscrire",
  'scansuccess.welcomepoints.title': 'Points de bienvenue',
  'scansuccess.welcomepoints.pointsLabel': 'Points attribués',
  'scansuccess.brandproductreview.title': 'Avis sur la marque et le produit',
  'scansuccess.brandproductreview.leaveReview': 'Laisser un avis',
  'scansuccess.productreview.title': 'Avis produit',
  'scansuccess.productreview.submit': "Soumettre l'avis",
  'scansuccess.congratulations.title': 'Félicitations !',
  'scansuccess.congratulations.message': 'Vous avez gagné des points — consultez votre tableau de bord pour les réclamer.',
  'scansuccess.noAccount': "Vous n'avez pas de compte ?",
  'scansuccess.signup': "S'inscrire",

  "user.register.createProfile": "Créer un compte",
  "user.register.creatingProfile": "Création du compte...",
  "user.register.termsOfService": "Conditions d'utilisation",
  "user.register.privacyPolicy": "Politique de confidentialité",

  'dashboard.multiplescans.title': 'Scans multiples',
  'dashboard.multiplescans.instructions': 'Gérez plusieurs scans et récompenses ensemble.',
  'dashboard.title': 'Bienvenue !',
  'dashboard.balance': 'Votre solde',
  'dashboard.balance-sub': 'points',
  'dashboard.redeem': 'Échanger',
  'dashboard.stat': 'Scans totaux',
  'dashboard.label': 'Récompenses gagnées',
  'dashboard.redeem.title': 'Échangez vos points',
  'dashboard.redeem.success': 'Échanger récompenses',
  'dashboard.primary-sub': 'Utilisez vos points pour débloquer des récompenses',
  'dashboard.secondary-btn': 'Scanner encore',
  'dashboard.secondary': 'Parrainer un ami',
  'dashboard.loyalty': "Niveaux de fidélité",
  'dashboard.5000pts': '5000 points',
  'dashboard.100pts': "100 points jusqu'à Platinum",
  'dashboard.almost-there': 'Presque là !',
  'dashboard.recent': 'Activité récente',
  'settings.title': 'Paramètres',

  'settings.balance': 'Membre Gold',
  'settings.balance-sub': 'Points',
  'settings.redeem': 'Compte',
  'settings.stat': 'Modifier le profil',
  'settings.label': 'Mettre à jour les informations personnelles',
  'settings.redeem.title': 'Préférences',
  'settings.redeem.success': 'Notifications',
  'settings.primary-sub': 'Préférences push & e-mail',
  'settings.secondary-btn': 'Langue',
  'settings.secondary': 'Français',
  'settings.loyalty': 'Aide & Conditions',
  'settings.5000pts': 'Aide & Support',
  'settings.100pts': 'FAQ, contactez-nous',
  'settings.almost-there': 'Termes et conditions',
  'settings.recent': 'Informations légales',
  'settings.points': 'Politique de confidentialité',
  'settings.data': 'Protection des données',
  'settings.sign': 'Se déconnecter',

  'profile.balance': '% Terminé',
  'profile.balance-sub': '% restant',
  'profile.stat': 'Informations du profil',
  'profile.label': 'pt',
  'profile.redeem.title': 'Connecter les réseaux sociaux',
  'profile.redeem.success': 'Gagnez des points pour chaque connexion !',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Connectez vos réseaux sociaux pour un bonus de 20 points !',
  'profile.recent': 'Remplissez les champs suivants pour compléter votre profil et gagner ',
  
  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "Afrique du Sud",
  "country.BJ": "Bénin",
  "country.AE": "Émirats arabes unis",

  "dashboard.welcome": "Bienvenue!",
  "dashboard.user.unknown": "Utilisateur",
  "dashboard.balanceLabel": "Votre solde",
  "dashboard.coinsAlt": "pièces",
  "dashboard.pointsLabel": "points",
  "dashboard.redeemBtn": "Utiliser les points",
  "dashboard.totalScans": "Total des scans",
  "dashboard.rewardsWon": "Récompenses gagnées",
  "dashboard.redeemTitle": "Échangez vos points",
  "dashboard.redeemRewards": "Échanger les récompenses",
  "dashboard.redeemSub": "Utilisez vos points pour débloquer des récompenses",
  "dashboard.reviewProducts": "Évaluer les produits",
  "dashboard.referFriend": "Référer un ami",
  "dashboard.tiersTitle": "Niveaux de fidélité",
  "dashboard.tier.default": "Membre",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} jusqu'au niveau suivant",
  "dashboard.almostThere": "Presque là !",
  "dashboard.recentActivityTitle": "Activité récente",
  "dashboard.share.title": "Rejoignez Exceptional Brands",
  "dashboard.share.text": "Rejoignez-moi sur Exceptional Brands ! Gagnez des points en scannant des produits et obtenez des récompenses incroyables. Utilisez mon lien de parrainage : {url}",
  "dashboard.shareModalTitle": "Partager avec des amis",
  "dashboard.shareModalDesc": "Partagez Exceptional Brands avec vos amis et gagnez des points bonus lorsqu'ils rejoignent !",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Votre lien de parrainage :",
  "dashboard.share.instagramCopied": "Lien copié dans le presse-papiers - collez dans Instagram",
  "dashboard.footerCopyright": "Copyright © {year}. Propulsé par Exceptional Brands",
  "dashboard.aria.welcome": "Panneau de bienvenue",
  "dashboard.aria.notifications": "Notifications",
  "dashboard.aria.settings": "Paramètres",
  'dashboard.redeem.points': 'Échangez vos points',
  'dashboard.redeem.subtitle': 'Utilisez vos points pour débloquer des récompenses',
  'dashboard.redeem.sub': 'points',
  'dashboard.redeem.progress': 'Progression vers Platinum',
  'dashboard.redeem.stat': 'Récompenses disponibles',
  'dashboard.redeem.label': 'Échanger',
  'dashboard.redeem.need': 'Requis',
  'dashboard.redeem.prize': 'Téléchargement du prix',
  'dashboard.redeem.scan': 'Plus vous scannez plus vos chances de gagner augmentent',
  'dashboard.redeem.recent': 'Activité récente',
  'global.back': 'Retour',
  'global.next': 'Suivant',
  'global.search.placeholder': 'Rechercher...',
  'validation.required': 'Ce champ est requis',
  'error.404.title': 'Page introuvable',
  'error.404.subTitle': 'Désolé, nous ne trouvons pas la page que vous recherchez.',
};
